// extracted by mini-css-extract-plugin
export default {"body":"error_body__2U0BK","link":"error_link__gzK2F","menu":"error_menu__ej0DW","container":"error_container__tbaLC","text":"error_text__9vNVf","image":"error_image__smjKQ"};